import { tv } from '@simplywallst/ui-core/next';

export const styles = tv({
  slots: {
    fieldset: 'tw-reset group/field m-0 flex flex-col gap-x0_75',
    inputEl:
      'tw-reset h-x5 w-full select-none rounded-x0_5 bg-transparent px-x1_5 py-x1 pe-x5 text-xs text-[--s-field-input-color-text] caret-brand-01 group-data-[prefix=true]/input:ps-x5',
    input: [
      'tw-reset group/input relative h-x5 rounded-x0_5 p-0 text-xs font-normal',
      'border border-solid border-[--s-field-input-color-border]',
      'bg-[--s-field-input-color-bg]',
      'focus-outline opacity-70 transition-opacity',
      'group-focus-within/field:bg-[--s-field-input-focus-color-bg] group-focus-within/field:opacity-100',
      'inline-flex items-center justify-center gap-x0_5',
    ],
  },
  variants: {
    isDisabled: {
      true: {
        inputEl: 'pointer-events-none',
        input: 'opacity-30',
      },
    },
  },
  defaultVariants: {
    isDisabled: false,
  },
});
